import { Camera, Mic, ScanBarcode, Sparkles } from 'lucide-react';
import { useUI } from '../lib/ui';

/** The one-step logging entry point: type, talk, snap, or scan. */
export function Composer({ floating = false }: { floating?: boolean }) {
  const { openLog } = useUI();
  return (
    <div className={floating ? 'composer-float' : 'composer-inline'}>
      <div className="composer">
        <Sparkles size={20} className="composer__spark" aria-hidden="true" />
        <button className="composer__open" onClick={() => openLog({ tab: 'describe' })}>
          What did you eat?
        </button>
        <button className="composer__tool" aria-label="Log by voice" onClick={() => openLog({ tab: 'describe', mode: 'voice' })}>
          <Mic size={19} />
        </button>
        <button className="composer__tool" aria-label="Log with a photo" onClick={() => openLog({ tab: 'describe', mode: 'photo' })}>
          <Camera size={19} />
        </button>
        <button className="composer__tool" aria-label="Scan a barcode" onClick={() => openLog({ tab: 'describe', mode: 'barcode' })}>
          <ScanBarcode size={19} />
        </button>
      </div>
    </div>
  );
}
